
import Vue from 'vue'
import Calendar from '@/product/components/DeliveryDateCalendar.vue'
import ModalSimple from '@/common/components/ModalSimple.vue'

export default Vue.extend({
  name: 'DeliveryDateModal',
  components: {
    Calendar,
    ModalSimple
  },
  props: {
    zipCode: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: true
    }
  },
  data(): {
    addressModal: boolean
  } {
    return {
      addressModal: true
    }
  },
  computed: {
    product() {
      return this.$store.getters.product
    },
    estimate() {
      return this.$store.getters.estimate
    },
    quantity(): number {
      return this.estimate.quantity
    },
    isTrial(): boolean {
      return this.estimate.trial
    },
    isPlainGood(): boolean {
      return this.estimate.plain_good
    },
    selectedEditPatternLabel(): string {
      return this.$store.getters.selectedEditPattern?.edit_pattern
    },
    selectedColorPatternOptionLabel(): string {
      return this.$store.getters.selectedColorPatternOption?.color_pattern
    },
    orderMethodLabel(): string {
      if (this.isTrial) return 'サンプル印刷'
        else if (this.isPlainGood) return '無地サンプル'
          else return 'オリジナル印刷'
    },
    wrappingMethodLabel(): string {
      return this.estimate.wrapping_selected_option?.display_name
    },
    isShowWrappingMethod(): boolean {
      return this.wrappingMethodLabel !== 'なし'
    }
  },
  methods: {
    close() {
      this.$emit('onClose')
    },
    goBack() {
      this.$emit('onBack')
    }
  }
})
